import { createReducer, createAction } from "redux-act";
import { ConnectionStatus } from "@evergis/api";

const RSSPA = "@@RSSPA";

export enum PublicConnectionStatus {
  InvalidWorkspace = "InvalidWorkspace",
  Unauthorized = "Unauthorized",
  SessionClosed = "SessionClosed",
}
export type SpState = ConnectionStatus | PublicConnectionStatus;

export const connectionChange = createAction<SpState>(`${RSSPA}/connection`);
export const reducer = createReducer<SpState>({}, ConnectionStatus.Initialized);

reducer.on(connectionChange, (_, status) => status);
